import useSummary from "../../../../../../hooks/summary/useSummary";
import { apiEndPoints } from "../../../../../../config/config";
import { useEffect, useState } from "react";
import { updateErrorMessage } from "../../../../../../store/error_slice";
import { useDispatch } from "react-redux";
import { clearStorage } from "../../../../../../config/config";
import Wrapper from "./components/Wrapper/main";
import {
  cropActivityApiResponseType,
  cropActivityResponseType,
  farmActivityResposeType,
  farmActivityApiResponseType,
  farmerActivityApiResponseType,
  farmerActivityResposeType,
} from "./activity.types";
import APIError from "../../../../../../api/Error/error";
const Activities = () => {
  const [farmListData, setFarmListData] = useState<farmActivityResposeType[]>(
    [],
  );
  const [farmerListData, setFarmerListData] = useState<
    farmerActivityResposeType[]
  >([]);
  const [cropListData, setCropListData] = useState<cropActivityResponseType[]>(
    [],
  );
  const processActivityData = (
    data:
      | farmActivityResposeType[]
      | cropActivityResponseType[]
      | farmerActivityResposeType[],
    type: "farm" | "crop" | "farmer",
  ) =>
    data.map(
      (
        e:
          | farmActivityResposeType
          | cropActivityResponseType
          | farmerActivityResposeType,
      ) => ({
        ...e,
        type,
      }),
    );
  const activityHelper = ({
    apiRes,
    type,
  }: {
    apiRes:
      | farmActivityApiResponseType
      | cropActivityApiResponseType
      | farmerActivityApiResponseType;
    type: "farm" | "crop" | "farmer";
  }) => {
    const { results } = apiRes;
    const processedData = processActivityData(results, type);
    if (type === "farm") {
      setFarmListData(processedData as farmActivityResposeType[]);
    } else if (type === "crop") {
      setCropListData(processedData as cropActivityResponseType[]);
    } else {
      setFarmerListData(processedData as farmActivityResposeType[]);
    }
  };

  const {
    SUMMARY_API_CROPACTIVITIES,
    SUMMARY_API_FARMACTIVITIES,
    SUMMARY_API_FARMERACTIVITIES,
  } = apiEndPoints;
  const dispatch = useDispatch();
  const farmActivitySucces = (apiRes: farmActivityApiResponseType) => {
    activityHelper({
      apiRes,
      type: "farm",
    });
  };
  const cropActivitySuccess = (apiRes: cropActivityApiResponseType) => {
    activityHelper({
      apiRes,
      type: "crop",
    });
  };
  const farmerActivitySuccess = (apiRes: farmerActivityApiResponseType) => {
    activityHelper({
      apiRes,
      type: "farmer",
    });
  };
  const refetchHandler = () => {
    farmActivityRefetch();
    farmerActivityRefetch();
    cropActivtyRefetch();
  };
  const onActivityError = (error: APIError) => {
    try {
      if (error.statusCode === 401) {
        //logout
        clearStorage();
        window.location.reload();
        // navigate("/login");
      } else {
        dispatch(
          updateErrorMessage({ message: error.message, type: "summary" }),
        );
      }
    } catch (err) {
      dispatch(
        updateErrorMessage({
          message: "Something went wrong",
          type: "summary",
        }),
      );
    }
  };
  const {
    isLoading: farmActivityLoading,
    isFetching: farmActivityFetching,
    isError: farmActivityError,
    refetch: farmActivityRefetch,
  } = useSummary({
    queryKey: ["farm-activities"],
    onSucces: farmActivitySucces,
    onError: onActivityError,
    url: SUMMARY_API_FARMACTIVITIES,
  });
  const {
    isLoading: farmerActivityLoading,
    isFetching: farmerActivityFetching,
    isError: farmerActivityError,
    refetch: farmerActivityRefetch,
  } = useSummary({
    queryKey: ["farmer-activities"],
    onSucces: farmerActivitySuccess,
    onError: onActivityError,
    url: SUMMARY_API_FARMERACTIVITIES,
  });
  const {
    isLoading: cropActivityLoading,
    isFetching: cropActivityFetching,
    isError: cropActivityError,
    refetch: cropActivtyRefetch,
  } = useSummary({
    queryKey: ["crop-activities"],
    onSucces: cropActivitySuccess,
    onError: onActivityError,
    url: SUMMARY_API_CROPACTIVITIES,
  });

  useEffect(() => {
    farmActivityRefetch();
    farmerActivityRefetch();
    cropActivtyRefetch();
  }, []);
  return (
    <Wrapper
      farmActivityLoading={farmActivityLoading}
      farmActivityFetching={farmActivityFetching}
      farmerActivityLoading={farmerActivityLoading}
      farmerActivityFetching={farmerActivityFetching}
      cropActivityLoading={cropActivityLoading}
      cropActivityFetching={cropActivityFetching}
      farmListData={farmListData}
      farmerListData={farmerListData}
      cropListData={cropListData}
      farmActivityError={farmActivityError}
      farmerActivityError={farmerActivityError}
      cropActivityError={cropActivityError}
      refetchHandler={refetchHandler}
    />
  );
};
export default Activities;
